import { useEffect } from "react";

import { MARKETING_TRACKERS } from "@/consent/trackerSnippets";
import { useConsentStore } from "@/consent/useConsentStore";

export default function ConsentScripts(): null {
  const marketing = useConsentStore((s) => s.consent.marketing);

  useEffect(() => {
    if (!marketing) return;
    for (const tracker of MARKETING_TRACKERS) {
      try {
        // _document's script elements exist even when their guard blocked
        // execution, so only isLoaded() can decide; snippets self-guard.
        if (tracker.isLoaded()) continue;
        const script = document.createElement("script");
        script.textContent = tracker.snippet;
        document.body.appendChild(script);
      } catch (error) {
        console.error(`Failed to load ${tracker.id}:`, error);
      }
    }
  }, [marketing]);

  return null;
}
